/* NOTE: For list of API definitions https://phobos.us-east-1.prod.atl-paas.net/swagger-ui/index.html?configUrl=/v3/api-docs/phobos.json/swagger-config */

// NOTE: refactor: improve this so that we can abstract calls and their accepted params here.
// rationale:
// - if contract changes, we change it here and all places in the app will tell you where it breaks.
// - don't have to go to lengths of creating external generated api ts-client dependency, keeps it simple.
export const ENDPOINTS = {
  SIGNALFLOW: '/signalflow/detectors/error-budget/check',
} as const;

// NOTE: refactor:
// The name meta isn't very descriptive. Make this / use an endpoint definition config file.
// Everything below here is Tech Debt AFAIK

const incidentsMeta = {
  copy: {
    default: 'Incident',
    plural: 'Incidents without associated SLOs',
  },
  endpoints: {
    report: '/hot/search',
    unassociated: '/hot/unassociated',
    slo: (sloPublicId: string) => `/hot/slo/${sloPublicId}`,
  },
} as const;

const primary = {
  pollinator: {
    copy: { default: 'Pollinator', plural: 'Pollinators' },
    endpoints: { resource: '/pollinator', autocomplete: '/pollinator/autocomplete' },
  },
  pollinatorArchetype: {
    copy: { default: 'Pollinator Archetype', plural: 'Pollinator Archetypes' },
    endpoints: {
      resource: '/pollinator-archetype',
      autocomplete: '/pollinator-archetype/autocomplete',
    },
  },
  capability: {
    copy: {
      default: 'Capability',
      plural: 'Capabilities',
    },
    endpoints: {
      resource: '/capability',
      autocomplete: '/capability/autocomplete',
      report: '/capability/search',
      slos: (capabilityPublicId: string) => `/capability/${capabilityPublicId}/slos`,
      events: (capabilityPublicId: string) => `/capability/${capabilityPublicId}/events`,
      eventsSummary: (capabilityPublicId: string) =>
        `/capability/${capabilityPublicId}/events/summary`,
      history: (capabilityPublicId: string) => `/capability/${capabilityPublicId}/history`,
    },
  },
  product: {
    copy: {
      default: 'Product',
      plural: 'Products',
    },
    endpoints: {
      resource: '/product',
      autocomplete: '/product/autocomplete',
      report: '/product/search',
      history: (productPublicId: string) => `/product/${productPublicId}/history`,
    },
  },
  team: {
    copy: {
      default: 'Team',
      plural: 'Teams',
    },
    endpoints: {
      resource: '/team',
      autocomplete: '/team/autocomplete',
      report: '/team/search',
      history: (teamPublicId: string) => `/team/${teamPublicId}/history`,
    },
  },
} as const;

type AtlassianUserType = 'user';
const atlassianUserMeta = {
  copy: {
    default: 'User',
    plural: 'Users',
  },
  endpoints: {
    resource: '/user',
    autocomplete: '/user/autocomplete',
  },
} as const;

type SLOReportType = 'slo';
type SLOGroupType = 'slogroup';
export const sloMeta = {
  copy: {
    default: 'SLO',
    plural: 'SLOs',
  },
  endpoints: {
    resource: '/slo',
    events: (sloPublicId: string) => `/slo/${sloPublicId}/events`,
    eventsList: (sloPublicId: string) => `/slo/${sloPublicId}/events/list`,
    history: (sloPublicId: string) => `/slo/${sloPublicId}/history`,
  },
} as const;

export const sloGroupMeta = {
  copy: {
    default: 'SLO Group',
    plural: 'SLO Groups',
  },
  endpoints: {
    resource: '/slogroup',
    slo: `/slogroup/slo`,
    autocomplete: (sloGroupPublicId: string, mimir: boolean = false, dynamic: boolean = false) =>
      `/slogroup/${sloGroupPublicId}${mimir ? '/mimir' : ''}${
        dynamic ? '/cohortNames' : '/cohorts'
      }/autocomplete`,
    sync: (sloGroupPublicId: string) => `/slogroup/sync/${sloGroupPublicId}`,
    slos: (sloGroupPublicId: string, mimir: boolean = false) =>
      `/slogroup/${sloGroupPublicId}${mimir ? '/mimir' : ''}/slos`,
    members: (sloGroupPublicId: string) => `/slogroup/${sloGroupPublicId}/members`,
    history: (sloGroupPublicId: string) => `/slogroup/${sloGroupPublicId}/history`,
  },
} as const;

// we need this line to guarantee that CRUDableType stays correct, and so that we can type ReportType
const toExport = {
  ...primary,
  incidents: incidentsMeta,
  slo: sloMeta,
  slogroup: sloGroupMeta,
  user: atlassianUserMeta,
  signalflow: {
    endpoints: { check: ENDPOINTS.SIGNALFLOW },
  },
  perfportal: {
    endpoints: { autocomplete: '/perfportal/autocomplete' },
  },
  org: {
    endpoints: {
      resource: '/org',
      autocomplete: '/org/autocomplete',
    },
  },
  service: {
    endpoints: {
      autocomplete: '/service/autocomplete',
    },
  },
};

export default toExport;

export { primary as reports };

export type PrimaryType = keyof typeof primary;
export type CRUDableType = PrimaryType | SLOReportType | SLOGroupType;
export type Api2UiMappingType = CRUDableType | 'org';
export type AutocompletableType =
  | keyof typeof primary
  | AtlassianUserType
  | 'perfportal'
  | 'org'
  | 'slogroup'
  | 'service';
